module.exports = __webpack_public_path__ + "static/img/yj_l2_1.bc3c292.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/hardWare/yj/yj_l2_1.png
// module id = jt5y
// module chunks = 0